export default "__VITE_ASSET__CL6rZ1Ud__"